import { type Balance, balanceSchema } from '@ytclip/shared'
import { apiRequest } from '@/lib/api-client.ts'

export function fetchBalance(): Promise<Balance> {
  return apiRequest('/me/balance', balanceSchema)
}
